export const TEAM_GOTO_PHONE_NUMBERS = [
    '+13854400564',
    '+13854400565',
    '+13854400566',
    '+13854400567',
    '+13854400568',
    '+13854400569',
    '+13854400570',
    '+13854400571',
    '+13854400572',
    '+13854400573',
    '+13854400574',
    '+13854400575',
];
//# sourceMappingURL=teamGoToPhoneNumbers.js.map